import React from 'react';
import type { FC } from 'react';

import { CardElement } from '@stripe/react-stripe-js';
import type { StripeCardElementOptions } from '@stripe/stripe-js';

import { COLORS, SANS_SERIF_FONT_FAMILY } from '@clutter/clean';

const OPTIONS: StripeCardElementOptions = {
  style: {
    base: {
      fontSize: '16px',
      fontFamily: SANS_SERIF_FONT_FAMILY,
      lineHeight: '26px',
      padding: '0px',
      color: COLORS.storm,
      '::placeholder': {
        color: COLORS.hippo,
      },
    },
  },
};

export const StyledCardElement: FC = () => <CardElement options={OPTIONS} />;
